import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import CommentIcon from "@atlaskit/icon/core/comment";
import EpicIcon from "@atlaskit/icon/core/epic";
import WorkItemsIcon from "@atlaskit/icon/core/work-items";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";
import { ContentTypeImage } from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/content-type-image.tsx";
import type {
    TabProps,
    TabType
} from "@/templates/home/home-page/src/sections-v2/jsm-xflow-hero/tab-type.tsx";

import { tabbedHeroSectionCollaborateMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

type CollaborateContentTypeProps = TabProps;

export const CollaborateContentType: TabType =
    ({}: CollaborateContentTypeProps) => {
        const intl = useIntl();
        const { createAnalyticsEvent } = useAnalyticsEvents();
        const { user } = useUserContext();

        return (
            <ContentTypeImage
                imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/w3t1q5q216ig76vqf8uw64s328t01641.webp"
                imageAlt="This is an image of Jira Product Discovery's ideas linked to delivery work."
                title={intl.formatMessage(
                    tabbedHeroSectionCollaborateMessages.contentTitle
                )}
                description={intl.formatMessage(
                    tabbedHeroSectionCollaborateMessages.contentDescription
                )}
                hideSeparator={true}
                iconCollection={[
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionCollaborateMessages.contentFeaturePoint1
                        ),
                        icon: <EpicIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionCollaborateMessages.contentFeaturePoint2
                        ),
                        icon: <WorkItemsIcon label="" />
                    },
                    {
                        description: intl.formatMessage(
                            tabbedHeroSectionCollaborateMessages.contentFeaturePoint3
                        ),
                        icon: <CommentIcon label="" />
                    }
                ]}
                cta={
                    <Link
                        href={"/software/jira/product-discovery"}
                        text={intl.formatMessage(
                            tabbedHeroSectionCollaborateMessages.contentCta
                        )}
                        type={"primary"}
                        dataEventProps={{
                            "data-product-key": "jiraProductDiscovery",
                            "data-event-component": "linkButton",
                            "data-event-container": "tabsMenu",
                            "data-event": "clicked",
                            "data-label": "try-it-out",
                            "data-label-english":
                                "Explore Jira Product Discovery",
                            "data-track-event":
                                "jpd-pt.content-types.collaborate.cta"
                        }}
                        onClick={() => {
                            createAnalyticsEvent({
                                eventName: "jpd-crossflow-tab-cta-clicked",
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "linkButton",
                                actionSubjectId: "jpdCrossFlowHeroSection",
                                attributes: {
                                    reactComponent: "CollaborateContentType",
                                    tab: "collaborate",
                                    userTeamType:
                                        user.extended_profile?.team_type
                                }
                            }).fire();
                        }}
                    />
                }
                reverseLayout
            />
        );
    };
